import { Link } from "react-router-dom";
import { useTeachers } from "@/hooks/useCatalog";
import LoadingState from "../components/LoadingState";
import ErrorState from "../components/ErrorState";

export default function Ogretmenlerim() {
  const { data: teachers, loading, error, reload } = useTeachers();

  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={error} onRetry={reload} />;

  const list = teachers ?? [];

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">Öğretmenlerim</h1>
          <p className="text-sm md:text-base text-foreground-600 mt-1">
            Sana eşlik eden öğretmenler.
          </p>
        </div>
      </div>

      {!list.length&&<section className="rounded-xl border p-6"><h2 className="font-bold">Henüz öğretmen atanmadı</h2><p className="mt-2">Hazır konu anlatımlarıyla çalışmaya devam edebilir, öğretmen desteği için bizimle iletişime geçebilirsin.</p><Link to="/ogrenci/derslerim" className="mr-4 underline">Derslerime git</Link><Link to="/iletisim" className="underline">Destek al</Link></section>}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {list.map((teacher) => (
          <div
            key={teacher.id}
            className="bg-background-50 rounded-xl border border-background-200 p-5 flex flex-col items-center text-center hover:border-primary-300 transition-colors"
          >
            <div className="w-20 h-20 rounded-full overflow-hidden bg-background-100 shrink-0">
              <img src={teacher.avatar} alt={teacher.name} className="w-full h-full object-cover object-top" />
            </div>
            <h3 className="mt-4 font-heading font-semibold text-base text-foreground-950">{teacher.name}</h3>
            <p className="text-sm text-foreground-500 mt-0.5">{teacher.subject}</p>

            <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1">
                <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
                {teacher.rating}
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-vidicon-line" aria-hidden="true"></i>
                {teacher.liveCount} ders
              </span>
            </div>

            <p className="mt-3 text-xs text-foreground-600 leading-relaxed flex-1">{teacher.description}</p>

            <Link
              to={`/ogrenci/mesajlar?teacher=${encodeURIComponent(teacher.id)}`}
              className="mt-4 w-full h-9 rounded-md bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-600 transition-colors inline-flex items-center justify-center gap-1.5 whitespace-nowrap"
            >
              <i className="ri-chat-3-line" aria-hidden="true"></i>
              Mesaj Gönder
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}